module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    attrs: {
      "epub:type": "chapter"
    }
  }, [_c('p', {
    staticClass: "h1",
    staticStyle: {
      "color": "#82a339"
    },
    attrs: {
      "id": "d7e1478749"
    }
  }, [_c('b', [_vm._v("CHINESE DUMPLINGS")])]), _vm._v(" "), _c('p', {
    staticClass: "ext",
    attrs: {
      "id": "d7e1479249"
    }
  }, [_c('b', [_c('i', [_vm._v("Steamed dumplings are fun to make at home. Have them for brunch; it’s the way the Chinese enjoy them.")])])]), _vm._v(" "), _c('p', {
    staticClass: "h4",
    staticStyle: {
      "color": "#496210"
    },
    attrs: {
      "id": "d7e1480249"
    }
  }, [_c('b', [_vm._v("Prep: 45 minutes      Cook: 10 minutes")])]), _vm._v(" "), _c('p', {
    staticClass: "ul",
    attrs: {
      "id": "d7e1480749"
    }
  }, [_vm._v("2 cups packed sliced Napa cabbage "), _c('br'), _vm._v(" (Chinese cabbage)")]), _vm._v(" "), _c('p', {
    staticClass: "ul",
    attrs: {
      "id": "d7e1481349"
    }
  }, [_vm._v("8 ounces ground pork")]), _vm._v(" "), _c('p', {
    staticClass: "ul",
    attrs: {
      "id": "d7e1481649"
    }
  }, [_vm._v("1 green onion, finely chopped")]), _vm._v(" "), _c('p', {
    staticClass: "ul",
    attrs: {
      "id": "d7e1481949"
    }
  }, [_vm._v("1½ teaspoons minced, peeled fresh ginger")]), _vm._v(" "), _c('p', {
    staticClass: "ul",
    attrs: {
      "id": "d7e1483149"
    }
  }, [_vm._v("2 tablespoons soy sauce")]), _vm._v(" "), _c('p', {
    staticClass: "ul",
    attrs: {
      "id": "d7e1483449"
    }
  }, [_vm._v("1 tablespoon dry sherry")]), _vm._v(" "), _c('p', {
    staticClass: "ul",
    attrs: {
      "id": "d7e1483749"
    }
  }, [_vm._v("2 teaspoons cornstarch")]), _vm._v(" "), _c('p', {
    staticClass: "ul",
    attrs: {
      "id": "d7e1484049"
    }
  }, [_vm._v("36 wonton wrappers (9 ounces)")]), _vm._v(" "), _c('p', {
    staticClass: "ul",
    attrs: {
      "id": "d7e1484449"
    }
  }, [_vm._v("1 large egg white, beaten "), _c('br'), _vm._v(" "), _c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/Text/West_9781618371621_epub_c43_r1#d7e1501249"
    }
  }, [_vm._v("Soy Dipping Sauce")])]), _vm._v(" "), _c('p', {
    staticClass: "pub",
    staticStyle: {
      "margin-top": "1.5em"
    },
    attrs: {
      "id": "d7e1485249"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#c15b49"
    }
  }, [_c('b', [_vm._v("1.")])]), _vm._v(" Prepare filling: In 2-quart saucepan, heat "), _c('i', [_vm._v("1 inch water ")]), _vm._v("to boiling over high heat. Add cabbage and heat to boiling. Cook 1 minute; drain. Immediately rinse with cold running water to stop cooking. With hands, squeeze out as much water from cabbage as possible. Finely chop cabbage. Squeeze out any remaining water from cabbage; place in medium bowl. Stir in pork, green onion, ginger, soy sauce, sherry, and cornstarch until well blended.")]), _vm._v(" "), _c('p', {
    staticClass: "ser"
  }, [_c('img', {
    staticStyle: {
      "max-width": "100%"
    },
    attrs: {
      "alt": "9781618371621_0049_001",
      "src": "Images/9781618371621_0049_001.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "pub",
    attrs: {
      "id": "d7e1489649"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#c15b49"
    }
  }, [_c('b', [_vm._v("2.")])]), _vm._v(" Arrange half of wonton wrappers on waxed paper. With pastry brush, brush each wrapper lightly with egg white. Spoon 1 rounded teaspoon filling into center of each wrapper. Bring two opposite corners of each wonton wrapper together over filling; pinch and pleat edges together to seal in filling. Repeat with remaining wrappers, egg white, and filling.")]), _vm._v(" "), _c('p', {
    staticClass: "pub",
    attrs: {
      "id": "d7e1493849"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#c15b49"
    }
  }, [_c('b', [_vm._v("3.")])]), _vm._v(" In deep nonstick 12-inch skillet, heat "), _c('i', [_vm._v("1 inch water ")]), _vm._v("to boiling over high heat. Place all dumplings, pleated edges up, in one layer in skillet. With spatula, move dumplings gently to prevent them from sticking to bottom of skillet; heat to boiling. Reduce heat; cover and simmer until dumplings are cooked through, about 5 minutes.")]), _vm._v(" "), _c('p', {
    staticClass: "pub",
    attrs: {
      "id": "d7e1497649"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#c15b49"
    }
  }, [_c('b', [_vm._v("4.")])]), _vm._v(" Meanwhile, prepare Soy Dipping Sauce.")]), _vm._v(" "), _c('p', {
    staticClass: "pub",
    attrs: {
      "id": "d7e1498349"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#c15b49"
    }
  }, [_c('b', [_vm._v("5.")])]), _vm._v("With slotted spoon, transfer dumplings to platter. Serve with dipping sauce. Makes 36 dumplings.")]), _vm._v(" "), _c('p', {
    staticClass: "ntx",
    attrs: {
      "id": "d7e1499849"
    }
  }, [_vm._v("Each dumpling without sauce: About 40 calories, 2g protein, 5g carbohydrate, 1g total fat (1g saturated), 5g cholesterol, 103g sodium.")]), _vm._v(" "), _c('p', {
    staticClass: "h4l",
    staticStyle: {
      "color": "#496210"
    },
    attrs: {
      "id": "d7e1501249"
    }
  }, [_c('b', [_vm._v("SOY DIPPING SAUCE")])]), _vm._v(" "), _c('p', {
    staticClass: "tx4",
    attrs: {
      "id": "d7e1501749"
    }
  }, [_vm._v("In small serving bowl, stir "), _c('b', [_vm._v("¼ cup soy sauce, ¼ cup seasoned rice vinegar or white wine vinegar, ")]), _vm._v("and "), _c('b', [_vm._v("2 tablespoons peeled fresh ginger, ")]), _vm._v("cut into very thin slivers, until blended. Makes about ½ cup.")]), _vm._v(" "), _c('p', {
    staticClass: "ntx",
    attrs: {
      "id": "d7e1506349"
    }
  }, [_vm._v("Each teaspoon: About 4 calories, 0g protein, 1g carbohydrate, 0g total fat (0g saturated), 0mg cholesterol, 221mg sodium.")]), _vm._v(" "), _c('p', {
    staticClass: "ser"
  }, [_c('img', {
    staticStyle: {
      "max-width": "100%"
    },
    attrs: {
      "alt": "9781618371621_0049_002",
      "src": "Images/9781618371621_0049_002.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "cap",
    attrs: {
      "id": "d7e18270250"
    }
  }, [_c('i', [_vm._v("Chinese Dumplings ")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-30b68ea2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/West_9781618371621_epub_c43_r1.vue
// module id = 195
// module chunks = 0